import React, { useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import AerolineasBaseForm from './aerolineas/AerolineasBaseForm';
import AerolineasCargoManager from './aerolineas/AerolineasCargoManager';

const ComplementoAerolineas = (props) => {
  let initialState = props.data || { Version: '1.0' };

  const [state, setState] = useState({
    data: { ...initialState },
    isValid: false,
  });

  const { data, isValid } = state;

  const handleOnChange = (event) => {
    const newState = {
      ...state,
      data: {
        ...state.data,
        ...event.data
      },
      isValid: event.isValid
    };

    setState(newState);
  }

  const handleOnManagerChange = (data) => {
    const newState = {
      ...state,
      data: {
        ...state.data,
        ...data
      },
    };

    setState(newState);
  }

  const handleOnAdd = () => {
    const complemento = {
      Aerolineas: data
    };

    props.onChange(complemento);

    clearState();
  }

  const clearState = () => {
    setState({
      ...state,
      data: {
        Version: '1.0'
      }
    });
  }

  const handleOnCancel = () => {
    props.onCancel('Aerolineas');

    clearState();
  }

  return (
    <>
      <div className="pb-4 text-right">
        <strong className="text-black text-upper">Complemento Aerolineas</strong>
      </div>

      <div className="pb-4">
        <div className="section pt-2">

          <Form autoComplete="off">

            <AerolineasBaseForm data={ data } onChange={ handleOnChange } />

            <AerolineasCargoManager data={ data } onChange={ handleOnManagerChange } />

            <div className="py-2"></div>

            <Row className="pb-3 text-right">
              <Col>
                <Button variant="secondary"
                  className="mr-3"
                  onClick={ handleOnCancel }
                >
                  Cancelar
                </Button>

                <Button variant="secondary"
                  disabled={ !isValid}
                  onClick={ handleOnAdd }
                >
                  Agregar complemento
                </Button>
              </Col>
            </Row>

          </Form>
        </div>
      </div>
    </>
  );
}

export default ComplementoAerolineas;